import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCaretLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.31 19.78a.75.75 0 0 1-1.06 0L8 12.53 7.47 12l.53-.53 7.25-7.25a.75.75 0 0 1 1.06 1.06L9.59 12l6.72 6.72a.75.75 0 0 1 0 1.06"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeft24);
